import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { createReducer } from '@lib/plugin-redux-core';
import { fileStorageHandlers } from './file-storage/file-storage.handler';
import { initialFileStorageState } from './file-storage/file-storage.state';
var initialState = {
  fileStorage: initialFileStorageState
};
export var fileManagementAppReducer = createReducer(initialState, _toConsumableArray(fileStorageHandlers));